import { render, staticRenderFns } from "./RemCancel.vue?vue&type=template&id=be870394&"
import script from "./RemCancel.vue?vue&type=script&lang=js&"
export * from "./RemCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports